import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_25: DocMigration = {
  maxSchemaVersion: "0.0.25",
  apply(json: any) {
    const embeddedGroups = json.electricalSystem.embeddedGroups;
    for (const groupId in embeddedGroups) {
      const embeddedGroup = embeddedGroups[groupId];

      // array of type any to avoid imporing types in migration files
      const newLoadArrays: any[] = [];

      for (const loadArray of embeddedGroup.loadArrays) {
        if (loadArray.type === "EMBEDDED") {
          for (const load of loadArray.loads) {
            newLoadArrays.push({ type: "LOAD", id: load });
          }
        } else {
          newLoadArrays.push(loadArray);
        }
      }
      embeddedGroup.loadArrays = newLoadArrays;
    }
    return json;
  },
};

export default migration_0_0_25;
